import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../_service/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  service = inject(AuthService)
  router = inject(Router)
  user: any;
  isLoading = true;
  isLoadingStats = true;
  isLoggingOut = false;

  // Mock stats data - replace with actual service calls
  stats = {
    orders: 127,
    revenue: 45230,
    responseTime: '12m'
  };

  ngOnInit(): void {
    this.loadUserProfile();
    this.loadStats();
  }

  loadUserProfile() {
    this.isLoading = true;
    // Simulate API call
    setTimeout(() => {
      this.user = this.service.getUser('user');
      this.isLoading = false;
    }, 800);
  }

  loadStats() {
    this.isLoadingStats = true;
    // Simulate stats API call
    setTimeout(() => {
      this.isLoadingStats = false;
    }, 1200);
  }

  logout() {
    this.isLoggingOut = true;

    // Simulate logout API call
    setTimeout(() => {
      this.service.logout();
      this.router.navigate(['/login']);
    }, 1000);
  }
}
